import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../pages/home/index.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '*',
      name: '404',
      component: () => import('../pages/home/index.vue')
    },
    {
      path: '/hair',
      name: 'hair',
      //  component: Hair
      component: () => import('../pages/hair/index.vue')
    },
    {
      path: '/shop-wholesale',
      name: 'Wholesale',
      component: () => import('../pages/wholesale/index.vue')
    },
    {
      path: '/whosalesDetails/:orderId?',
      name: 'whosalesDetails',
      component: () => import('../pages/wholesale/whosalesDetails.vue')
    },
    {
      path: '/forget',
      name: 'Forget',
      // component: Forget
      component: () => import('../pages/forget/index.vue')
    },
    {
      path: '/search/:value?',
      name: 'search',
      component: () => import('../pages/search/index.vue')
    },
    {
      path: '/brand/:brandName?',
      name: 'brand',
      component: () => import('../pages/brand/index.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/components/About'),
      meta: {
        title: 'About Us-ShopVidi.com'
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      // component: PrivacyPolicy,
      component: () => import('@/components/PrivacyPolicy'),
      meta: {
        title: 'Privacy Policy-ShopVidi.com'
      }
    },
    {
      path: '/bss-retailer-terms-of-service',
      name: '8privacy',
      component: () => import('@/components/8Policy')
    },
    {
      path: '/product-guidelines',
      name: '3privacy',
      component: () => import('@/components/3Policy')
    },
    {
      path: '/brand-terms-of-service',
      name: '5privacy',
      component: () => import('@/components/5Policy')
    },
    {
      path: '/retailer-terms-of-service',
      name: '6privacy',
      component: () => import('@/components/6Policy')
    },
    {
      path: '/product-guidelines',
      name: '3privacy',
      component: () => import('@/components/3Policy')
    },
    {
      path: '/brand-terms-of-service',
      name: '5privacy',
      component: () => import('@/components/5Policy')
    },
    {
      path: '/retailer-terms-of-service',
      name: '6privacy',
      component: () => import('@/components/6Policy')
    },
    {
      path: '/term-service',
      name: 'service',
      component: () => import('@/components/TermOfService'),
      meta: {
        title: 'Term of Service- ShopVidi.com'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/components/Contact'),
      meta: {
        title: 'Contact Us-ShopVidi.com'
      }
    },
    {
      path: '/return-policy',
      name: 'return',
      component: () => import('@/components/returnPolicy'),
      meta: {
        title: 'Return Policy-ShopVidi.com'
      }
    },
    {
      path: '/shipping-policy',
      name: 'shipping',
      component: () => import('@/components/ShippingPolicy'),
      meta: {
        title: 'Shipping Policy-ShopVidi.com'
      }
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('@/components/Success')
    },
    {
      path: '/category/:firstName?/:secondName?/:thirdName?',
      name: 'category',
      component: () => import('../pages/product/index.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/collection/:firstName?/:secondName?/:thirdName?',
      name: 'collection',
      component: () => import('../pages/product/index.vue'),
      meta: {
        keepAlive: true
      }
    },
    { path: '/credit-payment',
      name: 'creditPayment',
      component: () => import('../pages/credit-payment/index.vue')

    },
    {
      path: '/product/:url?',
      name: 'product',
      component: () => import('../pages/detail/index.vue')
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: () => import('../pages/logistic/logistic-detail')
    },
    {
      path: '/wholesale',
      name: 'wholesale-order',
      component: () => import('../pages/order/wholesale-order')
    },
    {
      path: '/unApply',
      name: 'unApply',
      component: () => import('../pages/apply/unApply')
    },
    {
      path: '/shoppingCart',
      name: 'shoppingCart',
      component: () => import('../pages/goods/shopping-cart/index'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/serviceOrder',
      name: 'serviceOrder',
      component: () => import('../pages/service-order/index'),
      meta: {
        keepAlive: false
      }
    },
    {
      // 退款（已发货，未发货）
      path: '/shipperRefund',
      name: 'shipperRefund',
      component: () => import('../pages/refund/shipped-refund'),
      meta: {
        keepAlive: false
      }
    },
    {
      // 退款（已发货，未发货）
      path: '/refundAudit',
      name: 'refundAudit',
      component: () => import('../pages/refund/refund-audit'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/checkout/:orderId?/:path?/:name?',
      name: 'checkout',
      component: () => import('../pages/checkout/index.vue')
    },
    {
      path: '/pay-result',
      name: 'pay-result',
      component: () => import('../pages/checkout/pay-result')
    },
    {
      path: '/menu/:key?',
      name: 'menu',
      component: () => import('../pages/components/menu-index')
    },
    {
      path: '/creditpayment',
      name: 'credit-payment',
      component: () => import('../pages/credit-payment/redirect-credit-payment')
    },
    {
      path: '/re-order',
      name: 're-order',
      component: () => import('../pages/goods/re-order/index')
    },
    {
      path: '/testPaBank',
      name: 'testPaBank',
      component: () => import('../pages/test-pa-bank/index')
    },
    {
      path: '/apply',
      name: 'apply',
      component: () => import('../pages/credit-payment/apply-now')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../pages/login/login-in')
    },
    {
      path: '/my-profile',
      name: 'my-profile',
      component: () => import('../pages/login/login-in')
    },
    {
      path: '/verify-email',
      name: 'verify-email',
      component: () => import('../pages/verify/email-index')
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: () => import('../pages/coupon/index.vue')
    },
    {
      path: '/slope-internal',
      name: 'slope-internal',
      component: () => import('../pages/internal-pc/index')
    },
    {
      path: '/slope-internal',
      name: 'slope-internal',
      component: () => import('../pages/internal-pc/index')
    },
    {
      path: '/get-sample',
      name: 'get-sample',
      component: () => import('../pages/order/sample-order')
    },
    {
      path: '/invoice/detail',
      name: 'Invoice Detail',
      component: () => import('../pages/invoice/invoice-detail-index')
    },
    {
      path: '/order/list',
      name: 'My Order',
      component: () => import('../pages/order/order-list')
    },
    {
      path: '/order/review',
      name: 'Order Review',
      component: () => import('../pages/order/order-review-page')
    },
    {
      path: '/order/order-details/:batchNo?',
      name: 'Order Details',
      component: () => import('../pages/order/batch-order-detail')
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: () => import('../pages/coupon/index')
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('../pages/help/index')
    },
    {
      path: '/vilocal/:brand',
      name: 'vi local',
      component: () => import('@/components/ViLocal')
    },
    {
      path: '/vilocal-zone',
      name: 'vilocal-zone',
      component: () => import('../pages/vilocal/vilocal-zone')
    },
    {
      path: '/boutique',
      name: 'boutique',
      component: () => import('../pages/vilocal/vilocal-zone')
    },
    {
      path: '/supply',
      name: 'supply',
      component: () => import('../pages/vilocal/vilocal-zone')
    },
    {
      path: '/vilocal-v3',
      name: 'vilocal-v3',
      component: () => import('../pages/vilocal/vilocal-v3')
    },
    {
      path: '/vilocal',
      name: 'vilocal',
      component: () => import('../pages/vilocal/vilocal')
    },
    {
      path: '/store-info',
      name: 'store-info',
      component: () => import('../pages/store/index')
    },
    {
      path: '/trustpilot',
      name: 'trustpilot',
      component: () => import('../components/trustpilotWidget')
    },
    {
      path: '/google-register',
      name: 'google-register',
      component: () => import('../pages/register/google-register')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js